import { GlobalStyles } from '@mui/material';

export const globalStyles = (
  <GlobalStyles
    styles={{
      body: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        backgroundColor: '#fff',
        color: '#14171a',
        margin: 0,
        padding: 0,
      },
      '#root': {
        backgroundColor: '#fff',
      },
      a: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        textDecoration: 'none',
        color: '#1da1f2',
        '&:hover': {
          color: '#1a91da',
          textDecoration: 'underline',
        },
      },
      ul: {
        listStyle: 'none',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.5rem',
        padding: 0,
        margin: 0,
      },
      '@keyframes fadeIn': {
        from: {
          opacity: 0,
        },
        to: {
          opacity: 1,
        },
      },
    }}
  />
);

